import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'James M.',
  role: 'Senior Club Coach',
  text: '"I bought it on a Thursday. By Friday night I had the whole month of training ready. I never improvise anymore."'
}, {
  name: 'Coach David',
  role: 'Youth Coach',
  text: '"Three players who were stuck improved their passing and support in the first month."'
}, {
  name: 'Priya T.',
  role: 'Academy Coach',
  text: '"I used to spend an hour building each session. Now it takes 5 minutes."'
}, {
  name: 'Paul A.',
  role: 'Junior Coach',
  text: '"The corrections bank changed how I talk to my players. I know exactly what to say and when."'
}, {
  name: 'Dean R.',
  role: 'Head Coach',
  text: '"The preseason plan saved my year. 22 players available for the first match. Zero injuries."'
}, {
  name: 'Marcus L.',
  role: 'Amateur Club Coach',
  text: '"I used the set pieces on Saturday. We beat a team that thrashed us last season."'
}];
export function ExtendedTestimonials() {
  return <section className="bg-ink-soft px-5 py-14 md:py-24" data-id="element-54" data-mp="380o4w7nff6fs">
      <div className="max-w-6xl mx-auto" data-id="element-55" data-mp="37z4qynp8t7h6">
        <div className="text-center mb-10 md:mb-14" data-id="element-56" data-mp="33ykqpb9dhnqt">
          <div className="flex justify-center gap-1.5 mb-4" aria-label="Rated 4.9 out of 5" data-id="element-57" data-mp="33z2km18kbpvk">
            {[...Array(5)].map((_, i) => <Star key={i} className="fill-acid text-acid" size={20} data-id="element-58" data-mp="3voyxyomvs1ti" data-mpi={i} />)}
          </div>
          <h2 className="font-display uppercase text-white text-[7vw] min-[430px]:text-3xl md:text-5xl leading-[1.05]" data-id="element-59" data-mp="3rpq83uuyoo38">
            Trusted by coaches — <span className="text-acid" data-id="element-60" data-mp="3mr58nxnja8fu">4.9/5.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-61" data-mp="3hpzf5xm1uh59">
          {testimonials.map(t => <figure key={t.name} className="bg-white p-5 md:p-7 flex flex-col h-full" data-id="element-62" data-mp="26b2bpip4bped">
              <div className="flex gap-1 mb-4" data-id="element-63" data-mp="27rzn7wen3syi">
                {[...Array(5)].map((_, i) => <Star key={i} className="fill-neon text-neon" size={14} data-id="element-64" data-mp="2crkmy91mw5ca" data-mpi={i} />)}
              </div>
              <blockquote className="text-gray-800 italic text-[0.95rem] md:text-base leading-relaxed flex-grow" data-id="element-65" data-mp="1yqhzpsywkozs">
                {t.text}
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-gray-200" data-id="element-66" data-mp="1p1zzbcujcjwo">
                <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-67" data-mp="1ozx0q4fbhigc">
                  {t.name}
                </span>{' '}
                <span className="text-gray-500 text-xs md:text-sm" data-id="element-68" data-mp="1g1lc27y0guqj">
                  {t.role}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}